import React from "react";
import * as Sentry from "@sentry/react";
import configs from "../config/app";
import { Box, Button } from "@mui/material";
/**
 * @recordUserSessions  The percentage of random user sessions to record for session replay (0.0 - 1.0)
 * @recordUserSessionsOnError  The percentage of user sessions to record for session replay WHEN ERROR OCCURS (0.0 - 1.0)
 * @recordPerformance  The percentage of user sessions to record for performance monitoring (0.0 - 1.0)
 * @envAllowed  The list of environments where Sentry is enabled
 */
const recordUserSessions = 0.1;
const recordUserSessionsOnError = 1.0;
const recordPerformance = 0.1;
const envAllowed = [
  "production",
  "staging",
  //'development'
];
// Only initialize Sentry in allowed environments
if (envAllowed.includes(configs.env)) {
  Sentry.init({
    dsn: configs.sentryUri,
    environment: configs.env,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // Capture console errors, warnings, and logs
      Sentry.captureConsoleIntegration({
        levels: ["error", "warn", "assert"],
      }),
      // Capture unhandled promise rejections
      Sentry.globalHandlersIntegration({
        onunhandledrejection: true,
        onerror: true,
      }),
      // Capture HTTP client errors
      Sentry.httpClientIntegration(),
    ],
    tracesSampleRate: recordPerformance,
    replaysSessionSampleRate: recordUserSessions,
    replaysOnErrorSampleRate: recordUserSessionsOnError,
  });
}
